import React, { useId } from "react";
import { Box, InputLabel } from "@mui/material";
import { DebouncedSearch } from "@components/DebouncedSearch";

interface Props {
  label: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
}

export const SearchSetting = ({
  label,
  placeholder,
  value,
  onChange,
}: Props) => {
  const id = useId();

  return (
    <Box>
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <DebouncedSearch
        id={id}
        placeholder={placeholder}
        value={value}
        onDebouncedChange={onChange}
        size="small"
        // As tall as the small selects next to it.
        sx={{ width: "100%", "& .MuiInputBase-root": { height: 36 } }}
      />
    </Box>
  );
};
